
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/add-listing/rega",
      function () {
        return require("private-next-pages/add-listing/rega/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/add-listing/rega"])
      });
    }
  